<template>
  <div class="container mt-2">
    <v-img
      class="content"
      :src="require('@/assets/this_is_not_part_of_the_arg.gif')"
    ></v-img>
  </div>
</template>

<script>
export default {
  name: "SecretJ",
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.content {
  max-height: 480px;
}
</style>
